import { jsx as _jsx } from "react/jsx-runtime";
import { LengthInput } from "../primitives/LengthInput";
export const VariableNumberEditor = ({ value, onChangeValue, readOnly, onClickValue, placeholderValue })=>{
    return /*#__PURE__*/ _jsx("div", {
        onClick: onClickValue,
        className: onClickValue ? "cursor-pointer" : "",
        children: /*#__PURE__*/ _jsx("div", {
            className: readOnly ? "pointer-events-none" : "",
            children: /*#__PURE__*/ _jsx(LengthInput, {
                iconType: "node-number",
                type: "number",
                readOnly: !!readOnly,
                placeholder: placeholderValue?.value.toString() || "",
                value: value?.value === undefined ? "" : value?.value.toString(),
                onClick: (e)=>{
                    onClickValue && e.preventDefault();
                    onClickValue && onClickValue();
                },
                onChange: (e)=>{
                    onChangeValue && onChangeValue(e.target.value == "" ? undefined : {
                        type: "variable-number",
                        value: parseFloat(e.target.value || "") || 0
                    });
                }
            })
        })
    });
};
